import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Image from "next/image";

const BrandIdentity = () => (
  <>
    <div className="py-24 md:px-4 xl:px-16 bg-black overflow-hidden md:overflow-auto">
      <div className="flex flex-col xl:flex-row">
        <div className="w-full xl:w-1/2">
          <div className="px-4 md:px-8 xl:px-16">
            <div className="pl-2">
              <Image
                alt="pen"
                src="/assets/case-study/kyc/pen.webp"
                width={21}
                height={21}
              />
            </div>
            <h3 className="text-3xl md:text-5xl font-medium text-white mb-8 md:mb-2">
              <span className="font-ubuntu">Brand Identity</span>
            </h3>
            <p className="text-xs mb-8 md:mb-0 md:text-lg font-light text-white">
              <span className="font-ubuntu">
                After doing lots of ideation, we came up with this concept where
                we combined a star, which stands for “Review,” & other alphabets
                from the name “Know Your Customer.”
              </span>
            </p>
            <span className="text-2xl font-normal text-white pb-16 md:pb-0 md:my-8 xl:my-4 flex items-center">
              <FontAwesomeIcon
                className="text-2xl text-white mr-4 w-7 h-7"
                icon={faStar}
              />
              +<h5 className="text-2xl font-normal text-white ml-4"> KYC</h5>
            </span>
          </div>
        </div>
        <div className="w-full xl:w-1/2">
          <div className="px-4 xl:px-0 text-center xl:text-end">
            <Image
              alt="Know Your Customer App star based logo"
              src="/assets/case-study/kyc/brand-logo.webp"
              width={631}
              height={316}
            />
          </div>
        </div>
      </div>
    </div>
    <div className="pr-4 md:pt-16 md:px-16 md:pb-32 bg-black text-center">
      <Image
        alt="Know Your Customer Logo"
        className="!px-4 xl:!px-0"
        src="/assets/case-study/kyc/kyc-logo.webp"
        width={651}
        height={197}
      />
    </div>
    <div className="px-4 py-16 md:px-8 bg-black flex justify-center">
      <Image
        alt="A lady vendor holding a phone, showing Know Your Customer App open on screen"
        src="/assets/case-study/kyc/lady-vendor.webp"
        width={1358}
        height={622}
      />
    </div>
  </>
);

export default BrandIdentity;
